'use client';

import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { http, WagmiProvider } from 'wagmi';
import { arbitrum, bsc } from 'wagmi/chains';
import { ReactNode, useMemo } from 'react';

export function Web3Provider({
  type,
  walletconnectProject,
  children,
}: {
  type: 'arbitrum' | 'bsc';
  walletconnectProject: string;
  children: ReactNode;
}) {
  const chain = useMemo(() => {
    switch (type) {
      case 'arbitrum':
        return arbitrum;
      default:
        return bsc;
    }
  }, [type]);

  const config = getDefaultConfig({
    appName: process.env.NEXT_PUBLIC_APP_NAME!,
    projectId: walletconnectProject,
    chains: [chain] /*[sepolia]*/,
    transports: {
      [chain.id]: http(),
      /*[sepolia.id]: http(),*/
    },
    ssr: true,
  });

  return <WagmiProvider config={config}>{children}</WagmiProvider>;
}
